import { render, staticRenderFns } from "./addNewsletter.vue?vue&type=template&id=72e52e54"
import script from "./addNewsletter.vue?vue&type=script&lang=js"
export * from "./addNewsletter.vue?vue&type=script&lang=js"
import style0 from "./addNewsletter.vue?vue&type=style&index=0&id=72e52e54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports